module.exports = __webpack_public_path__ + "img/webmoney.6bb8a8d4.svg";